import { render, staticRenderFns } from "./DiagnosticDetail.vue?vue&type=template&id=3a607f5b&"
import script from "./DiagnosticDetail.vue?vue&type=script&lang=js&"
export * from "./DiagnosticDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports